import { HeaderBase } from "../../shared/HeaderBase";
import searchbar from "../images/searchbar.png";
import logo from "../images/weltbild-logo.png";

export const Header = () => (
  <HeaderBase
    brand={
      <>
        <img
          src={logo}
          style={{
            height: 40,
          }}
          alt="Weltbild"
        />
        <img
          src={searchbar}
          style={{
            height: 40,
            marginLeft: 30,
          }}
          alt="Suche"
        />
      </>
    }
  />
);
